<header class="agpr-sharedReports-header u-srOnly">
    <h2> {{ 'Reports.sharedReports.header' | localize }} </h2>
</header>

<agpr-shared-reports-export
    [blocks]="blocks"
>
</agpr-shared-reports-export>

<main class="agpr-sharedReports">
    <section
        class="agpr-sharedReports-primaryWorkflow"
        [agprLoading]="searchLoading || deleteLoading"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <div class="agpr-sharedReports-topLockBar" role="group" [attr.aria-label]="'Reports.sharedReports.controls' | localize">
            <h3 class="u-srOnly">{{ 'toolbar' | localize }}</h3>
            <!-- top row-->
            <div
                class="agpr-sharedReports-toolbar"
                [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
                (@toolbarCollapsed.start)="onAnimationStart($event)"
                (@toolbarCollapsed.done)="onAnimationDone($event)"
            >
                <div class="agpr-sharedReports-toolbarColumn agpr-sharedReports-toolbarColumn--date">
                        <agpr-date-query-popup
                            [id]="id + '.dateRange'"
                            [header]="'Monitoring.dateQueryDialog.header'"
                            [(ngModel)]="startDateRange"
                            [options]="dateFilterOptions"
                            [hideDateTypeSelection]="true"
                            [searchRange]="searchRange"
                            (ngModelChange)="dateRangeChanged($event)"
                        >
                        </agpr-date-query-popup>
                </div>
                <div class="agpr-sharedReports-toolbarColumn  agpr-sharedReports-toolbarColumn--large">
                    <agpr-filter-dropdown
                        class="agpr-sharedReports-toolbar-dropdown"
                        [id]="id + '.resultsFilters'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Reports.sharedReports.filtersPlaceholder"
                        [ariaLabel]="'Reports.sharedReports.filterLabel' | localize"
                    ></agpr-filter-dropdown>

                    <div class="agpr-sharedReports-toolbar-chips">
                        <agpr-filter-chips
                            #filterChipsComponent
                            [id]="id + '.resultsFilters.chips'"
                        ></agpr-filter-chips>
                        <agpr-button
                            *ngIf="filterChipsComponent.chips.length > 1"
                            class="agpr-sharedReports-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            id="filterClear"
                            (click)="clearFilters()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Monitoring.result.filters.clear"
                            tooltipPosition="top"
                        ></agpr-button>
                        <agpr-button
                            [ngClass]="{
                                'agpr-sharedReports-toolbarIcon--lock': filtersLocked,
                                'agpr-sharedReports-toolbarIcon--unlock': !filtersLocked
                            }"
                            [style]="buttonTypes.icon"
                            [id]="id + '.filter.lock'"
                            (click)="sharedReportSearchService.setFiltersLocked(!filtersLocked)"
                            [icon]="filtersLocked ? 'fa-regular fa-lock fa-duotone' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="filtersLocked ? 'Monitoring.result.filters.unlock' : 'Monitoring.result.filters.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </div>
                </div>
                <div class="agpr-sharedReports-toolbarColumn agpr-sharedReports-toolbarColumn--right">
                    <agpr-sort-order
                        id="sharedReports-sortOrder"
                        tooltip="Reports.sharedReports.sortTool.tooptipInfo"
                        optionKey="enumValue"
                        optionLabel="displayString"
                    ></agpr-sort-order>
                </div>
            </div>

            <!-- bottom row-->
            <div class="agpr-sharedReports-toolbar agpr-sharedReports-toolbar--bottom">
                <div class="agpr-sharedReports-toolbarColumn agpr-sharedReports-selectAllToggle">
                    <agpr-checkbox
                        [id]="id + '_toggleSelectAll'"
                        [binary]="true"
                        [ngModel]="sharedReportList?.length > 0 && selectedItems.length === sharedReportList.length"
                        (ngModelChange)="toggleSelectAll()"
                        [disabled]="!sharedReportList?.length"
                        [label]="selectedItems.length || '0'"
                    ></agpr-checkbox>
                    <span class="agpr-sharedReports-totalCount">
                        <span class="agpr-sharedReports-totalCountText">
                            {{ 'Paginator.of' | localize }}
                        </span>
                        <span class="agpr-sharedReports-totalCountValue">
                            {{ reportCount }}
                        </span>
                        {{ 'Reports.sharedReports.reportCount' | localize }}
                    </span>
                </div>
                <div class="agpr-sharedReports-toolbarColumn agpr-sharedReports-toolbarColumn--right">
                    <agpr-paginator
                        id="sharedReports-paginator"
                        [maxNumberOfItems]="10000"
                        [isDisabled]="false"
                    >
                    </agpr-paginator>
                </div>
            </div>
        </div>
        <agpr-message
            *ngIf="expirationCount > 0"
            class="agpr-sharedReports-expirationInfo"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Reports.sharedReports.expirationInfo' | localize: { count: expirationCount } }}
        </agpr-message>
        <agpr-message
            *ngIf="sharedReportList?.length === 0"
            class="agpr-sharedReports-noSharedReports"
            [severity]="messageSeverityEnum.noContent"
        >
            <span
                class="agpr-mentionSearchResult-noMentionsFound"
            >
                {{ 'Monitor.leftSideBar.reports.noSharedReports' | localize }}
            </span>
        </agpr-message>
        <div class="agpr-sharedReports-centerPanel">
            <agpr-scroll-panel
                #scrollArea
                (scrolledTopChange)="onScroll($event)"
            >
                <div class="agpr-sharedReports-content">
                    <h3 class="u-srOnly">{{ 'results' | localize }}</h3>
                    <ul
                        [id]="id + '_sharedReportsList'"
                        agprListKeyboardNavigation
                        [focusOnChild]="true"
                        [list]="sharedReportList"
                        focusableElementCustomSelector=".agpr-sharedReportCard-wrapper"
                    >
                        <li *ngFor="let sharedReportListItem of sharedReportList; let i = index">
                            <agpr-shared-report-card
                                [id]="'sharedReportCard.' + i"
                                [sharedReportListItem]="sharedReportListItem"
                                [selectedResults]="selectedItems"
                                (selectionChanged)="selectedItems = $event"
                            ></agpr-shared-report-card>
                        </li>
                    </ul>
                </div>
            </agpr-scroll-panel>
        </div>
        <agpr-action-bar
            [headingContext]="'Reports.sharedReports.header' | localize"
        >
            <ng-template #left>
                <agpr-button
                    [id]="id + '.action.refresh'"
                    label="Reports.sharedReports.action.refresh"
                    [style]="buttonTypes.secondary"
                    (click)="refreshSharedReports()"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                <agpr-button
                    [id]="id + '.action.delete'"
                    label="Reports.sharedReports.action.delete"
                    [style]="buttonTypes.primary"
                    (click)="deleteSharedReports(selectedItems)"
                    [disabled]="!selectedItems?.length"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </section>
    <aside
        class="agpr-sharedReports-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar>
            <agpr-panel header="Reports.sharedReports.rhp.reportDetails">
                <agpr-attribute-list
                    [id]="id + '.reportDetail'"
                    [attributes]="sharedReportDetails"
                ></agpr-attribute-list>
            </agpr-panel>
            <agpr-panel
                header="Reports.sharedReports.rhp.sharedWith"
                [disableToggle]="sentDetails.length === 0"
            >
                <agpr-attribute-list
                    [id]="id + '.sharedWith'"
                    [attributes]="sentDetails"
                ></agpr-attribute-list>
                <!-- TODO NEP-4793 use the following when the backend can return the status of recipient -->
                <!-- <ng-container *ngFor="let recipient of focusedSharedReport.recipients">
                    <agpr-shared-report-recipient-card
                        [recipient]="recipient"
                    ></agpr-shared-report-recipient-card>
                </ng-container> -->
            </agpr-panel>
            <ng-template #footer>
                <agpr-action-bar
                    *ngIf="focusedSharedReport"
                    [headingContext]="'Reports.sharedReportEditDialog.report' | localize"
                    headingLevel="4"
                >
                    <ng-template #right>
                        <agpr-split-button
                            [style]="buttonTypes.tertiary"
                            [id]="id + '.actions'"
                            label="actions"
                            [options]="actions"
                            [panelPositionY]="'top'"
                            [panelPositionX]="'right'"
                        ></agpr-split-button>
                    </ng-template>
                </agpr-action-bar>
            </ng-template>
        </agpr-right-sidebar>
    </aside>
</main>
